const func = $target => {
    var $uploadModal = $target.find('#uploadModal'),
        $uploadOptions = $target.find('input[name=uploadOptions]'),
        $individualUploads = $target.find('[data-id="individual-uploads"]'),
        $bulkUploads = $target.find('[data-id="bulk-uploads"]'),
        $additionalFilesText = $bulkUploads.find('[data-id="additional-files-text"]'),
        $stlIntraoralScanner = $target.find('[data-id="stlIntraoralScanner"]'),
        $stlIntraoralScannerMessage = $target.find('[data-id="stlIntraoralScannerMessage"]');

    if ($uploadModal.length) {
        $uploadModal.on('show.bs.modal', function(event) {
            var button = $(event.relatedTarget),
                filetype = button.data('filetype'),
                fileAccept = button.data('accept'),
                intraoralscanner = button.data('id'),
                modal = $(this),
                $fileInput = modal.find('input[name=file]');

            modal.find('.modal-title').text('Upload new ' + filetype.replace(/-/g, ' ').toUpperCase() + ' file');
            modal.find('#filetype').val(filetype);
            modal.find('img').attr('src', $('#img-' + filetype).attr('src'));
            modal.find('p#modal-current-file').text($('#img-' + filetype).attr('alt'));

            if (fileAccept == 'video') {
                modal.find('input[name="file"]').attr('accept','video/*')
            }
            if (intraoralscanner == 'stlIntraoralScanner') {
                // modal.find('#intraoralScannerOption').val('true');
                $fileInput.prop('required',false);
                modal.find('[data-id="file-upload"]').addClass('d-none');
                modal.find('input[name="stlIntraoralScanner"]').val(true);
                $stlIntraoralScannerMessage.removeClass('d-none');

                // modal.find('#stlIntraoralScanner').on('change', function(e) {
                //     

                //     if ($(this).is(":checked")) {
                //         // remove require field from upload
                //         $fileInput.prop('required',false);
                //     } else {
                //         $fileInput.prop('required',true);
                //     }
                // })
            }
        });

        $uploadModal.on('hide.bs.modal', function(event) {
            var modal = $(this),
                $fileInput = modal.find('input[name=file]');
                
            modal.find('.modal-title').text('');
            modal.find('#filetype').val('');
            modal.find('img').attr('src', '');
            modal.find('p#modal-current-file').text('');
          
            // modal.find('#intraoralScannerOption').val('');
            // modal.find('[data-id="stlIntraoralScanner"]').addClass('d-none');
            modal.find('input[name=file]').prop('required',true);
            modal.find('input[name="file"]').removeAttr('accept')
            $stlIntraoralScanner.prop('checked',false);
            modal.find('[data-id="file-upload"]').removeClass('d-none');
            $stlIntraoralScannerMessage.addClass('d-none');
            $fileInput.prop('required',true);
        });

        var $uploadInput = $uploadModal.find('input:file');

        $uploadInput.bind('change', function() {
            if (this.files[0].size >= $uploadModal.find('#number-check').val()) {
                this.value = '';
                $('#upload-alert').append('This file is too large, please contact the System Administrator for advice.');
                $('#upload-alert').removeClass('d-none');
                $('#upload-alert').addClass('d-block');
            }
        });
    }

    $uploadOptions.prop('disabled', false).parent().removeClass('disabled');

    $uploadOptions.on('change', function() {
        // alert($('input[name=radioName]:checked', '#myForm').val());
        var $this = $(this);

        $uploadModal.find('#uploadType').val($this.val());

        if ($this.val() == 'individual') {
            if ($bulkUploads.hasClass('d-none')) {
                $bulkUploads.removeClass('d-none');
            }
            $additionalFilesText.html('<h5 class="mb-3">Additional files</h5><p>Please upload any additional files you consider useful for the DSD Planning Center team to refer to in the planning process such as Panoramic X-ray, Periapical X-ray files and other photos and videos.</p>');
            $individualUploads.removeClass('d-none');           

        } else if($this.val() == 'bulk') {
            if (!$individualUploads.hasClass('d-none')) {
                $individualUploads.addClass('d-none');
            }

            $additionalFilesText.html('<p>We encourage you to upload as many different patient files as possible to aid our smile designers in the planning process. However, there are THREE MANDATORY FILES you will need to upload:</p><ul><li>Facial Frontal Smile photo</li><li>Scanned model/mouth .STL: Maxillary</li><li>Scanned model/mouth .STL: Mandibular</li></ul>');
           
            if ($bulkUploads.hasClass('d-none')) {
                $bulkUploads.removeClass('d-none');
            }
        }
    });

    if($('#case-active-modal').data('display')) {
        $('#case-active-modal').modal();
    }

    window.loader.keys(['plupload'], function () {

        console.log('plupload loaded');

        $(".uploader").each(function() {

            var $this = $(this),
                fileType = $this.data('filetype'),
                mimeTypes = [
                    {title : "Image files", extensions : "jpg,jpeg,gif,png"},
                    {title : "Zip files", extensions : "zip"},
                    {title : "Rar files", extensions : "rar"},
                    {title : "Video files", extensions : "mov,mpeg,mp4,m4a,m4v,mpc,mpg"},
                    {title : "STL files", extensions : "stl"},
                    {title : "PDF files", extensions : "pdf"},
                    {title : "Powerpoint files", extensions : "ppt,pptx"},
                    {title : "Spreadsheet files", extensions : "csv,xls,xlsx"},
                    {title : "Word files", extensions : "doc,docx"},
                    {title : "PLY files", extensions : "ply"},
                ];
                
            // var button = el.attr("id") + "_uploader";

            if(fileType == 'stl') {
                mimeTypes = [
                    {title : "STL files", extensions : "stl"}
                ];
            } else  if(fileType == 'cbct') {
                mimeTypes = [
                    {title : "Zip files", extensions : "zip"},
                    {title : "Rar files", extensions : "rar"}
                ];
            }

            var uploader = $this.pluploadQueue({
                // General settings
                runtimes : 'html5',
                url : "/actions/dsd/projects/upload-files",
                
                chunk_size : '5mb',
                // rename : true,
                dragdrop: true,             
                filters : {
                    // Maximum file size
                    max_file_size : '5000mb',
                    // Specify what files to browse for
                    mime_types: mimeTypes,
                },
                headers: {
                    "X-CSRF-Token" : window.csrfTokenValue,
                },
                multipart_params : {
                    'projectRef': $target.data('case'),
                    'redirect': $target.data('redirect'),
                    'filetype': fileType,
                },
                max_retries: 3,
                multiple_queues: true,
                init : {
                    PostInit: function() {

                        console.log(fileType);

                        var $pluploadContainer = $('.plupload'),
                            $footer = $pluploadContainer.find('.plupload_filelist_footer');
                            
                        $pluploadContainer.find('.plupload_header').hide();

                        $pluploadContainer.find('.plupload_content').addClass('card font-size-85');
                        $pluploadContainer.find('.plupload_filelist_header').addClass('card-header');

                        $footer.addClass('card-footer');                        

                        $footer.find('.plupload_add').addClass('btn btn-primary text-white mr-2 mb-2 mb-lg-0');
                        $footer.find('.plupload_start').addClass('btn btn-outline mb-2 mr-2 mb-lg-0');
                        $footer.find('.plupload_file_status, .plupload_file_size').addClass('float-none float-lg-right text-left text-lg-right');
                        $footer.find('.plupload_progress').addClass('float-none float-lg-right');

                    },
                    BeforeUpload: function(uploader, file) {
                        var params = uploader.settings.multipart_params;
                        params.filesize = file.size;

                        console.log(file.size);
                    },
                    UploadComplete: function() {
                        if ( 
                            $individualUploads.hasClass('d-none') && 
                            $target.data('status') == 'pending' && 
                            $target.data('products') == true
                        ) {
                            var url = window.location.origin + window.location.pathname,
                                separator = url.indexOf('?') !== -1 ? '&' : '?';

                            window.location.href = url + separator + 'newActive=true';
                        } else {
                            
                            var html = `<svg class="align-self-center " xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" viewBox="0 0 20 20" width="20" height="20"><g transform="matrix(0.8333333333333334,0,0,0.8333333333333334,0,0)"><path d="M18.48,6.449a1.249,1.249,0,0,0-1.747.265l-5.924,8.04L7.042,11.74a1.251,1.251,0,0,0-1.563,1.953l4.783,3.826a1.263,1.263,0,0,0,1.787-.235l6.7-9.087A1.25,1.25,0,0,0,18.48,6.449Z" fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path><path d="M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z" fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path></g></svg>
                                    Required files successfully uploaded`;
                            $target.parent().find('[data-id="files-upload-message"]').removeClass('text-primary').addClass('text-success').html(html);
                        }
                    }
                }
            });
        });
    });
};

export default func;